export default __webpack_public_path__ + "6a7cbefa48b9cc7b8444fa493d5407da.png";